// removed by extract-text-webpack-plugin
module.exports = {"subNav":"qempo_Payments_subNav-3dT_Zn7"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/payments/components/Payments.scss
// module id = 1816
// module chunks = 0